/**
 * @generated SignedSource<<810fe289e89dffe6e6d286f199e38e1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type leadDetailsClaimDataRefreshQuery$variables = {
  id: string;
};
export type leadDetailsClaimDataRefreshQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"leadDetails_leadClaimData">;
  } | null;
};
export type leadDetailsClaimDataRefreshQuery = {
  response: leadDetailsClaimDataRefreshQuery$data;
  variables: leadDetailsClaimDataRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "leadDetailsClaimDataRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "leadDetails_leadClaimData"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "leadDetailsClaimDataRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "claimedBy",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Lead",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13e9f44fdb3d92ca7be41670bf355aa8",
    "id": null,
    "metadata": {},
    "name": "leadDetailsClaimDataRefreshQuery",
    "operationKind": "query",
    "text": "query leadDetailsClaimDataRefreshQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...leadDetails_leadClaimData\n    id\n  }\n}\n\nfragment leadDetails_leadClaimData on Lead {\n  id\n  claimedBy {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dde972bea345aa8b61201365a1cdcc99";

export default node;
